import React, { useMemo } from "react";

import Sidebar from "../Sidebar";
import Header from "../Header";
import ParentDashboard from "./ParentDashboard";
import NewMessagePopup from "../NewMessagePopup";
import { useAuth } from "../../context/AuthContext";
import { filterLinksByPermissions } from "../../config/permissions";

const ParentLayout = () => {
  const { user } = useAuth();
  const userRoles = useMemo(() => user?.roles || user?.role || [], [user?.roles, user?.role]);

  const allParentLinks = useMemo(() => ([
    { to: "/parent/home", label: "Home", feature: "home" },
    {
      to: "/parent/grading",
      label: "Grading",
      feature: "grading",
      children: [
        { to: "/parent/student-profiles", label: "Student Profiles", feature: "grading" },
        { to: "/parent/data-points-report", label: "View Data", feature: "viewData" },
      ],
    },
    {
      to: "/parent/action",
      label: "Action",
      feature: "action",
      children: [
        { to: "/parent/action/assignments", label: "Assignments", feature: "action" },
        { to: "/parent/action/goals", label: "Student Goals (Coming soon)", feature: "goals" },
        { to: "/parent/action/support", label: "Guided Actions", feature: "goals" },
      ],
    },
    {
      to: "/parent/connect",
      label: "Connect",
      feature: "connect",
      children: [
        { to: "/parent/connect/messages", label: "Messages", feature: "messaging" },
      ],
    },
    { to: "/parent/requests", label: "Record requests", feature: "requests" },
    {
      to: "/parent/help-support",
      label: "Help",
      feature: "helpSupport",
      children: [
        { to: "/parent/help-support", label: "Help & Support", feature: "helpSupport" },
        { to: "/parent/help-support/tutorials", label: "Tutorials", feature: "helpSupport" },
        { to: "/parent/surveys", label: "Surveys", feature: "helpSupport" },
      ],
    },
  ]), []);

  const parentLinks = useMemo(
    () => filterLinksByPermissions(allParentLinks, userRoles),
    [allParentLinks, userRoles]
  );

  return (
    <div className="ae-shell">
      <Sidebar links={parentLinks} />
      <div className="ae-shell-content">
        <Header />
        <main className="ae-shell-main">
          <ParentDashboard />
        </main>
      </div>
      <NewMessagePopup defaultRole="parent" />
    </div>
  );
};

export default ParentLayout;
